/* eslint-disable react/prop-types */
import { ClickAwayListener, Popper } from '@mui/material'
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import CONSTANTS, { PAGES_ROUTES } from '../../../Constants'
import { updateNotificationsIsRead } from '../../../Helpers/NotificationHelper'
import { useAppDispatch, useAppSelector } from '../../../Store/Hooks'
import { setLoader } from '../../../Store/Slice/loader.slice'
import {
  setUnreadNotifIds,
  updateNotificationsReadStatus,
} from '../../../Store/Slice/notifications.slice'
import NotificationListingWrapper from '../../Notifications/NotificationListing'
import MUIButton from '../MUI-Button'
import './header.scss'

interface NotifPopperProps {
  notificationAnchorEl: HTMLElement | null
  navigate: (path: string) => void
  setNotificationAnchorEl: (anchorEl: HTMLElement | null) => void
}

const NotifPopper: React.FC<NotifPopperProps> = ({
  notificationAnchorEl,
  navigate,
  setNotificationAnchorEl,
}) => {
  const location = useLocation()
  const dispatch = useAppDispatch()
  const { unReadNotifIds } = useAppSelector((state) => state.notifications)
  const handleCloseNotifications = () => {
    setNotificationAnchorEl(null)
  }

  const isNotificationOpen = Boolean(notificationAnchorEl)

  // inside your component
  const unReadNotifIdsRef = useRef(unReadNotifIds)

  // always keep latest unReadNotifIds in the ref
  useEffect(() => {
    unReadNotifIdsRef.current = unReadNotifIds
  }, [unReadNotifIds])

  useEffect(() => {
    return () => {
      // cleanup uses latest ref value, not stale closure
      redirectToAllNotificationsPage(false, unReadNotifIdsRef.current)
    }
  }, [])

  const redirectToAllNotificationsPage = async (
    isNavigate = true,
    notifIds: string[] = unReadNotifIds,
  ) => {
    handleCloseNotifications()
    if (notifIds.length > 0 && !location.pathname.includes(PAGES_ROUTES.AllNotificationsPage)) {
      dispatch(setLoader(true))
      await updateNotificationsIsRead(
        dispatch,
        setUnreadNotifIds,
        updateNotificationsReadStatus,
        notifIds,
      )
      dispatch(setLoader(false))
    }
    if (isNavigate) {
      navigate(PAGES_ROUTES.AllNotificationsPage)
    }
  }

  return (
    <Popper
      open={isNotificationOpen}
      anchorEl={notificationAnchorEl}
      placement='bottom-end'
      className='notification-popper'
      sx={{
        zIndex: 1201,
        backgroundColor: '#fff',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        padding: '16px',
        width: '400px',
      }}
    >
      <ClickAwayListener onClickAway={handleCloseNotifications}>
        <div>
          <NotificationListingWrapper isPopup onClickNotification={handleCloseNotifications} />
          <div style={{ marginTop: '20px' }}>
            <MUIButton
              type='button'
              fullWidth
              variant='contained'
              label={CONSTANTS.ALL_NOTIFICATIONS}
              handleClickCB={redirectToAllNotificationsPage}
            />
          </div>
        </div>
      </ClickAwayListener>
    </Popper>
  )
}

export default NotifPopper
